import "bootstrap/dist/css/bootstrap.min.css";
import BarGraph from "components/graphs/BarGraph";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";

const SBASPositioningAccuracyCard = ({ innerRef, data }) => {
  const renderGraphs = (satellites) => {
    return satellites.map((satellite, index) => {
      var width = 400;
      var height = 0;
      return (
        <React.Fragment key={index}>
          {satellite.operations.map((operation, index) => {
            operation.plots.length === 1 ? (height = 400) : (height = 200);
            return (
              <React.Fragment key={index}>
                {operation.plots.length === 1 ? (
                  <p className="text-justify">
                    {operation.name} accuracy plots with SBAS GEO{" "}
                    {satellite.prn} (ICAO threshold:{" "}
                    {operation.plots[0].thresholdValues[0]}m)
                  </p>
                ) : (
                  ""
                )}
                {operation.plots.length === 2 ? (
                  <p className="text-justify">
                    {operation.name} accuracy plots with SBAS GEO{" "}
                    {satellite.prn} (ICAO threshold:{" "}
                    {operation.plots[0].thresholdValues[0]}m for HPE and{" "}
                    {operation.plots[1].thresholdValues[0]}m for VPE)
                  </p>
                ) : (
                  ""
                )}

                <Col xxl={{ span: 11, offset: 1 }}>
                  <Row>
                    {operation.plots.map((plot, index) => {
                      return (
                        <React.Fragment key={index}>
                          <Col
                            sm={{ span: 12, offset: 0 }}
                            xxl={
                              height === 400
                                ? { span: 12, offset: 0 }
                                : { span: 5, offset: 0 }
                            }
                          >
                            <BarGraph
                              width={width}
                              height={height}
                              dataset={plot}
                            />
                          </Col>
                        </React.Fragment>
                      );
                    })}
                  </Row>
                </Col>
              </React.Fragment>
            );
          })}
        </React.Fragment>
      );
    });
  };

  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Positioning accuracy
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          The positioning accuracy represents the 95th percentile of the
          position error measured, intended as the difference between the
          estimated position by the receiver and the reference position,
          calculated over a 24-hours interval.
        </p>

        {renderGraphs(data.satellites)}
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <SBASPositioningAccuracyCard innerRef={ref} {...props} />
  ))
);
